import { Paper } from '@mui/material'
import { memo, PropsWithChildren } from 'react'

/**
 * Shared surface for right sidebar widget tabs.
 * Renders immediately with Paper background so #181818 default never shows while content loads.
 */
function WidgetbarPageShell({ children }: PropsWithChildren) {
    return (
        <Paper
            elevation={0}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                height: '100%',
                minHeight: 0,
                width: '100%',
                borderTopRightRadius: '6px',
                overflow: 'hidden',
                bgcolor: 'background.paper'
            }}
        >
            {children}
        </Paper>
    )
}

function widgetbarPageShellPropsAreEqual(
    prev: PropsWithChildren,
    next: PropsWithChildren
): boolean {
    return prev.children === next.children
}

export default memo(WidgetbarPageShell, widgetbarPageShellPropsAreEqual)
